import {post} from '../utils/fetch-wrapper';
import {API} from '../routes';

/* istanbul ignore next */
const ACTIONS = {
    FETCH_RECENT_ACTIVITY: 'FETCH_RECENT_ACTIVITY',
    FETCH_RECENT_ACTIVITY_START: 'FETCH_RECENT_ACTIVITY_START',
    FETCH_RECENT_ACTIVITY_SUCCESS: 'FETCH_RECENT_ACTIVITY_SUCCESS',
    FETCH_RECENT_ACTIVITY_ERROR: 'FETCH_RECENT_ACTIVITY_ERROR',
    REMOVE_RECENT_ACTIVITY_SEARCH: 'REMOVE_RECENT_ACTIVITY_SEARCH',
    REMOVE_RECENT_ACTIVITY_PROPERTY: 'REMOVE_RECENT_ACTIVITY_PROPERTY',
    CHANGE_RECENT_ACTIVITY_CARD_INDEX: 'CHANGE_RECENT_ACTIVITY_CARD_INDEX' // RecentActivityCarousel
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    fetchRecentActivity: () => ({type: ACTIONS.FETCH_RECENT_ACTIVITY}),
    fetchRecentActivityStart: () => ({type: ACTIONS.FETCH_RECENT_ACTIVITY_START}),
    fetchRecentActivitySuccess: (payload) => ({type: ACTIONS.FETCH_RECENT_ACTIVITY_SUCCESS, payload}),
    fetchRecentActivityError: (payload) => ({type: ACTIONS.FETCH_RECENT_ACTIVITY_ERROR, payload}),
    removeRecentActivitySearch: (payload) => {
        const {propertyIds, scratchpadId} = payload;
        post(`${API}/recent-activity/deleteByIds`, {
            ids: [
                ...propertyIds,
                scratchpadId
            ]
        });

        return {type: ACTIONS.REMOVE_RECENT_ACTIVITY_SEARCH, payload};
    },
    removeRecentActivityProperty: (payload) => {
        const {scratchpadId} = payload;
        post(`${API}/recent-activity/deleteByIds`, {
            ids: [
                scratchpadId
            ]
        });

        return {type: ACTIONS.REMOVE_RECENT_ACTIVITY_PROPERTY, payload};
    },
    // RecentActivityCarousel
    changeRecentActivityCardIndex: (payload) => ({type: ACTIONS.CHANGE_RECENT_ACTIVITY_CARD_INDEX, payload})
};

export default {...ACTIONS, ...ACTION_CREATORS};



// WEBPACK FOOTER //
// ./src/universal/recent-activity/actions.js